import React from "react";

const dashboardIcon = () => (
  <svg
    id="test"
    width="23"
    height="20"
    viewBox="0 0 22 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Union">
      <path
        id="Union_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2V6H19V2H2ZM2 14V7H14V14H2ZM15 14H19V7H15V14ZM1 0C0.447715 0 0 0.447715 0 1V14V16H2H19H21V14V1C21 0.447715 20.5523 0 20 0H1Z"
      />
    </g>
  </svg>
);

const interestTrackingIcon = () => (
  <svg
    id="test"
    width="22"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19 15.18V7C19 4.79 17.21 3 15 3C12.79 3 11 4.79 11 7V17C11 18.1 10.1 19 9 19C7.9 19 7 18.1 7 17V8.82C8.16 8.4 9 7.3 9 6C9 4.34 7.66 3 6 3C4.34 3 3 4.34 3 6C3 7.3 3.84 8.4 5 8.82V17C5 19.21 6.79 21 9 21C11.21 21 13 19.21 13 17V7C13 5.9 13.9 5 15 5C16.1 5 17 5.9 17 7V15.18C15.84 15.59 15 16.69 15 18C15 19.66 16.34 21 18 21C19.66 21 21 19.66 21 18C21 16.7 20.16 15.6 19 15.18ZM6 7C5.45 7 5 6.55 5 6C5 5.45 5.45 5 6 5C6.55 5 7 5.45 7 6C7 6.55 6.55 7 6 7ZM18 19C17.45 19 17 18.55 17 18C17 17.45 17.45 17 18 17C18.55 17 19 17.45 19 18C19 18.55 18.55 19 18 19Z" />
  </svg>
);

const studentsIcon = () => (
  <svg
    id="test"
    width="23"
    height="20"
    viewBox="0 0 22 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Student">
      <mask
        id="mask0_1236_3718"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="22"
        height="20"
      >
        <rect
          id="Bounding box"
          x="0.5"
          y="0.833374"
          width="22"
          height="18.3333"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1236_3718)">
        <path
          id="diversity_3"
          d="M0.5 17.8334V13.8334C0.5 13.2667 0.695833 12.7917 1.0875 12.4084C1.47917 12.025 1.95 11.8334 2.5 11.8334H5.775C6.10833 11.8334 6.425 11.9167 6.725 12.0834C7.025 12.25 7.26667 12.475 7.45 12.7584C7.93333 13.4084 8.52917 13.9167 9.2375 14.2834C9.94583 14.65 10.7 14.8334 11.5 14.8334C12.3167 14.8334 13.0792 14.65 13.7875 14.2834C14.4958 13.9167 15.0833 13.4084 15.55 12.7584C15.7667 12.475 16.0208 12.25 16.3125 12.0834C16.6042 11.9167 16.9083 11.8334 17.225 11.8334H20.5C21.0667 11.8334 21.5417 12.025 21.925 12.4084C22.3083 12.7917 22.5 13.2667 22.5 13.8334V17.8334H15.5V15.5584C14.9167 15.975 14.2875 16.2917 13.6125 16.5084C12.9375 16.725 12.2333 16.8334 11.5 16.8334C10.7833 16.8334 10.0833 16.7209 9.4 16.4959C8.71667 16.2709 8.08333 15.95 7.5 15.5334V17.8334H0.5ZM11.5 13.8334C10.8667 13.8334 10.2667 13.6875 9.7 13.3959C9.13333 13.1042 8.65833 12.7 8.275 12.1834C7.99167 11.7667 7.6375 11.4375 7.2125 11.1959C6.7875 10.9542 6.325 10.8334 5.825 10.8334C6.19167 10.2167 6.96667 9.72921 8.15 9.37087C9.33333 9.01254 10.45 8.83337 11.5 8.83337C12.55 8.83337 13.6667 9.01254 14.85 9.37087C16.0333 9.72921 16.8083 10.2167 17.175 10.8334C16.6917 10.8334 16.2333 10.9542 15.8 11.1959C15.3667 11.4375 15.0083 11.7667 14.725 12.1834C14.3583 12.7167 13.8917 13.125 13.325 13.4084C12.7583 13.6917 12.15 13.8334 11.5 13.8334ZM3.5 10.8334C2.66667 10.8334 1.95833 10.5417 1.375 9.95837C0.791667 9.37504 0.5 8.66671 0.5 7.83337C0.5 6.98337 0.791667 6.27087 1.375 5.69587C1.95833 5.12087 2.66667 4.83337 3.5 4.83337C4.35 4.83337 5.0625 5.12087 5.6375 5.69587C6.2125 6.27087 6.5 6.98337 6.5 7.83337C6.5 8.66671 6.2125 9.37504 5.6375 9.95837C5.0625 10.5417 4.35 10.8334 3.5 10.8334ZM19.5 10.8334C18.6667 10.8334 17.9583 10.5417 17.375 9.95837C16.7917 9.37504 16.5 8.66671 16.5 7.83337C16.5 6.98337 16.7917 6.27087 17.375 5.69587C17.9583 5.12087 18.6667 4.83337 19.5 4.83337C20.35 4.83337 21.0625 5.12087 21.6375 5.69587C22.2125 6.27087 22.5 6.98337 22.5 7.83337C22.5 8.66671 22.2125 9.37504 21.6375 9.95837C21.0625 10.5417 20.35 10.8334 19.5 10.8334ZM11.5 7.83337C10.6667 7.83337 9.95833 7.54171 9.375 6.95837C8.79167 6.37504 8.5 5.66671 8.5 4.83337C8.5 3.98337 8.79167 3.27087 9.375 2.69587C9.95833 2.12087 10.6667 1.83337 11.5 1.83337C12.35 1.83337 13.0625 2.12087 13.6375 2.69587C14.2125 3.27087 14.5 3.98337 14.5 4.83337C14.5 5.66671 14.2125 6.37504 13.6375 6.95837C13.0625 7.54171 12.35 7.83337 11.5 7.83337Z"
        />
      </g>
    </g>
  </svg>
);

const instructorsIcon = () => (
  <svg
    id="test"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Instructor">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2H0V3V16.5V17.5H1H3.5C4.05228 17.5 4.5 17.0523 4.5 16.5C4.5 15.9477 4.05228 15.5 3.5 15.5H2V4H19V15.5H17.5C16.9477 15.5 16.5 15.9477 16.5 16.5C16.5 17.0523 16.9477 17.5 17.5 17.5H20H21V16.5V3V2H20H1ZM10.6748 11.5C9.84147 11.5 9.13314 11.2083 8.5498 10.625C7.96647 10.0417 7.6748 9.33333 7.6748 8.5C7.6748 7.65 7.96647 6.9375 8.5498 6.3625C9.13314 5.7875 9.84147 5.5 10.6748 5.5C11.5248 5.5 12.2373 5.7875 12.8123 6.3625C13.3873 6.9375 13.6748 7.65 13.6748 8.5C13.6748 9.33333 13.3873 10.0417 12.8123 10.625C12.2373 11.2083 11.5248 11.5 10.6748 11.5ZM5 14.5V18.1278H16.35V14.5C15.9833 13.8833 15.2083 13.3958 14.025 13.0375C12.8417 12.6792 11.725 12.5 10.675 12.5C9.625 12.5 8.50833 12.6792 7.325 13.0375C6.14167 13.3958 5.36667 13.8833 5 14.5Z"
      />
    </g>
  </svg>
);

const coursesIcon = () => (
  <svg
    id="test"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Course">
      <mask
        id="mask0_1236_3737"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="22"
        height="20"
      >
        <rect
          id="Bounding box"
          y="0.375"
          width="22"
          height="19.25"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_1236_3737)">
        <path
          id="bookmarks"
          d="M4 19.375V5.375C4 4.825 4.19583 4.35417 4.5875 3.9625C4.97917 3.57083 5.45 3.375 6 3.375H16C16.55 3.375 17.0208 3.57083 17.4125 3.9625C17.8042 4.35417 18 4.825 18 5.375V19.375L11 16.375L4 19.375ZM6 16.325L11 14.175L16 16.325V5.375H6V16.325ZM19 17.375V2.375H2V0.375H19C19.55 0.375 20.0208 0.570833 20.4125 0.9625C20.8042 1.35417 21 1.825 21 2.375V17.375H19Z"
        />
      </g>
    </g>
  </svg>
);

const seminarsIcon = () => (
  <svg
    id="test"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Seminar">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 8C12.6569 8 14 6.65685 14 5C14 3.34315 12.6569 2 11 2C9.34315 2 8 3.34315 8 5C8 6.65685 9.34315 8 11 8ZM6 13.6278L5 11C5.36667 10.3833 6.14167 9.89583 7.325 9.5375C8.50833 9.17917 9.625 9 10.675 9C11.725 9 12.8417 9.17917 14.025 9.5375C15.2083 9.89583 15.9833 10.3833 16.35 11L15.35 13.6278H6ZM0 14H1.82391C1.515 12.5619 1.74476 10.2234 4.01363 8.1655C4.00467 8.11166 4 8.05638 4 8C4 7.44772 4.44772 7 5 7C5.55228 7 6 7.44772 6 8C6 8.55228 5.55228 9 5 9C4.87737 9 4.75989 8.97792 4.65133 8.93753C2.56508 10.8535 2.55389 12.9503 2.85353 14H21V16H18V18H3V16H0V14Z"
      />
    </g>
  </svg>
);

const schoolsIcon = () => (
  <svg
    id="test"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="school">
      <mask
        id="mask0_1236_3758"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="22"
        height="20"
      >
        <rect id="Bounding box" x="0.5" width="22" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1236_3758)">
        <path
          id="school_2"
          d="M12.5 21L5.5 17.2V11.2L1.5 9L12.5 3L23.5 9V17H21.5V10.1L19.5 11.2V17.2L12.5 21ZM12.5 12.7L19.35 9L12.5 5.3L5.65 9L12.5 12.7ZM12.5 18.725L17.5 16.025V12.25L12.5 15L7.5 12.25V16.025L12.5 18.725Z"
        />
      </g>
    </g>
  </svg>
);

const reportIcon = () => (
  <svg
    id="test"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="summarize">
      <mask
        id="mask0_1236_3767"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect id="Bounding box" x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1236_3767)">
        <path
          id="summarize_2"
          d="M8.5 9C8.78333 9 9.02083 8.90417 9.2125 8.7125C9.40417 8.52083 9.5 8.28333 9.5 8C9.5 7.71667 9.40417 7.47917 9.2125 7.2875C9.02083 7.09583 8.78333 7 8.5 7C8.21667 7 7.97917 7.09583 7.7875 7.2875C7.59583 7.47917 7.5 7.71667 7.5 8C7.5 8.28333 7.59583 8.52083 7.7875 8.7125C7.97917 8.90417 8.21667 9 8.5 9ZM8.5 13C8.78333 13 9.02083 12.9042 9.2125 12.7125C9.40417 12.5208 9.5 12.2833 9.5 12C9.5 11.7167 9.40417 11.4792 9.2125 11.2875C9.02083 11.0958 8.78333 11 8.5 11C8.21667 11 7.97917 11.0958 7.7875 11.2875C7.59583 11.4792 7.5 11.7167 7.5 12C7.5 12.2833 7.59583 12.5208 7.7875 12.7125C7.97917 12.9042 8.21667 13 8.5 13ZM8.5 17C8.78333 17 9.02083 16.9042 9.2125 16.7125C9.40417 16.5208 9.5 16.2833 9.5 16C9.5 15.7167 9.40417 15.4792 9.2125 15.2875C9.02083 15.0958 8.78333 15 8.5 15C8.21667 15 7.97917 15.0958 7.7875 15.2875C7.59583 15.4792 7.5 15.7167 7.5 16C7.5 16.2833 7.59583 16.5208 7.7875 16.7125C7.97917 16.9042 8.21667 17 8.5 17ZM5.5 21C4.95 21 4.47917 20.8042 4.0875 20.4125C3.69583 20.0208 3.5 19.55 3.5 19V5C3.5 4.45 3.69583 3.97917 4.0875 3.5875C4.47917 3.19583 4.95 3 5.5 3H16.5L21.5 8V19C21.5 19.55 21.3042 20.0208 20.9125 20.4125C20.5208 20.8042 20.05 21 19.5 21H5.5ZM5.5 19H19.5V9H15.5V5H5.5V19Z"
        />
      </g>
    </g>
  </svg>
);

const settingsIcon = () => (
  <svg
    id="test"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="settings_suggest">
      <mask
        id="mask0_1236_3775"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect id="Bounding box" x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1236_3775)">
        <path
          id="settings_suggest_2"
          d="M18.7846 8.673L17.7808 6.5038L15.6116 5.49995L17.7808 4.4961L18.7846 2.3269L19.7885 4.4961L21.9577 5.49995L19.7885 6.5038L18.7846 8.673ZM20.7846 15.8269L20.0423 14.2423L18.4577 13.5L20.0423 12.7577L20.7846 11.1731L21.5269 12.7577L23.1115 13.5L21.5269 14.2423L20.7846 15.8269ZM8.22698 21.4999L7.9462 19.3038C7.75517 19.2345 7.55548 19.1358 7.34715 19.0076C7.1388 18.8794 6.97053 18.7512 6.84233 18.623L4.79618 19.5153L2.73853 15.9346L4.52313 14.6307C4.49108 14.4012 4.47505 14.191 4.47505 14C4.47505 13.8089 4.49108 13.5987 4.52313 13.3692L2.73853 12.0653L4.79618 8.4846L6.84233 9.37693C6.97053 9.24871 7.1388 9.1205 7.34715 8.9923C7.55548 8.86409 7.75517 8.76536 7.9462 8.69613L8.22698 6.49998H12.3423L12.623 8.69613C12.8141 8.76536 13.0138 8.86409 13.2221 8.9923C13.4305 9.1205 13.5987 9.24871 13.7269 9.37693L15.7731 8.4846L17.8307 12.0653L16.0461 13.3692C16.0782 13.5987 16.0942 13.8089 16.0942 14C16.0942 14.191 16.0782 14.4012 16.0461 14.6307L17.8307 15.9346L15.7731 19.5153L13.7269 18.623C13.5987 18.7512 13.4305 18.8794 13.2221 19.0076C13.0138 19.1358 12.8141 19.2345 12.623 19.3038L12.3423 21.4999H8.22698ZM10.2846 16.7307C11.041 16.7307 11.6853 16.4647 12.2173 15.9326C12.7494 15.4006 13.0154 14.7564 13.0154 14C13.0154 13.2436 12.7494 12.5993 12.2173 12.0673C11.6853 11.5352 11.041 11.2692 10.2846 11.2692C9.52823 11.2692 8.884 11.5352 8.35195 12.0673C7.8199 12.5993 7.55387 13.2436 7.55387 14C7.55387 14.7564 7.8199 15.4006 8.35195 15.9326C8.884 16.4647 9.52823 16.7307 10.2846 16.7307Z"
        />
      </g>
    </g>
  </svg>
);

const trainingIcon = () => (
  <svg
    width="14"
    height="20"
    viewBox="0 0 14 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 19C4 19.55 4.45 20 5 20H9C9.55 20 10 19.55 10 19V18H4V19ZM7 0C3.14 0 0 3.14 0 7C0 9.38 1.19 11.47 3 12.74V15C3 15.55 3.45 16 4 16H10C10.55 16 11 15.55 11 15V12.74C12.81 11.47 14 9.38 14 7C14 3.14 10.86 0 7 0ZM9.85 11.1L9 11.7V14H5V11.7L4.15 11.1C2.8 10.16 2 8.63 2 7C2 4.24 4.24 2 7 2C9.76 2 12 4.24 12 7C12 8.63 11.2 10.16 9.85 11.1Z" />
  </svg>
);

export {
  dashboardIcon,
  interestTrackingIcon,
  studentsIcon,
  instructorsIcon,
  coursesIcon,
  seminarsIcon,
  schoolsIcon,
  reportIcon,
  settingsIcon,
  trainingIcon,
};
